import { buildQuery } from "@/api/apiUtils";
import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IAttendanceCreatePayload,
  IAttendanceUpdatePayload,
  IAttendanceBiometricSyncPayload,
  IAttendanceListParams,
  IAttendanceMatrixParams,
  IAttendanceListResponse,
  IAttendanceMatrixResponse,
  IAttendanceDetailResponse,
  IAttendanceMutationResponse,
} from "@/interface/attendance.model";

export const AttendanceService = {
  createAttendance: async (
    payload: IAttendanceCreatePayload,
  ): Promise<IAttendanceMutationResponse> => {
    return callApi<IAttendanceMutationResponse>(API_ENDPOINT.createAttendance, {
      method: "POST",
      data: payload,
    });
  },

  syncBiometricAttendance: async (
    payload: IAttendanceBiometricSyncPayload,
  ): Promise<IAttendanceMutationResponse> => {
    return callApi<IAttendanceMutationResponse>(
      API_ENDPOINT.biometricSyncAttendance,
      { method: "POST", data: payload },
    );
  },

  getAttendanceList: async (
    params: IAttendanceListParams = {},
  ): Promise<IAttendanceListResponse> => {
    return callApi<IAttendanceListResponse>(
      `${API_ENDPOINT.attendanceList}${buildQuery(params)}`,
      { method: "GET" },
    );
  },

  getAttendanceMatrix: async (
    params: IAttendanceMatrixParams,
  ): Promise<IAttendanceMatrixResponse> => {
    return callApi<IAttendanceMatrixResponse>(
      `${API_ENDPOINT.attendanceMatrix}${buildQuery(params)}`,
      { method: "GET" },
    );
  },

  getAttendanceDetail: async (
    attendanceId: string,
  ): Promise<IAttendanceDetailResponse> => {
    return callApi<IAttendanceDetailResponse>(
      API_ENDPOINT.attendanceDetail.replace(":attendanceId", attendanceId),
      { method: "GET" },
    );
  },

  updateAttendance: async (
    attendanceId: string,
    payload: IAttendanceUpdatePayload,
  ): Promise<IAttendanceMutationResponse> => {
    return callApi<IAttendanceMutationResponse>(
      API_ENDPOINT.attendanceUpdate.replace(":attendanceId", attendanceId),
      { method: "PUT", data: payload },
    );
  },

  deleteAttendance: async (
    attendanceId: string,
  ): Promise<IAttendanceMutationResponse> => {
    return callApi<IAttendanceMutationResponse>(
      API_ENDPOINT.attendanceDelete.replace(":attendanceId", attendanceId),
      { method: "DELETE" },
    );
  },
};
